module.exports = {
    header: {
        dates: {
            date: 'СЕНТЯБРЯ 2021',
            place: 'МОСКВА ВНУКОВО-3',
        },
        slogan: `
      Не пропустите<br/>
      ключевое событие в мире<br/>
      бизнес-авиации <span>rubae</span>
      `,
        button: 'Станьте участником',
        registrationButton: 'Купить билет',
        saleMessage: 'Save up to 15% on booking till 31 May',
        countDown: {
            text: 'ДО НАЧАЛА ',
            day: ' д.',
            cancelText: 'Выставка отменена.',
        },
    },
    about: {
        visitors: 'Более 10000 посетителей',
        aircrafts: 'Более 20 самолетов и вертолетов',
        conference: 'Новая программа конференций',
        about: 'Узнать больше о выставке',
        marketing: 'Рекламные возможности',
        navigation: {
            exhibitors: {
                title: 'Участникам',
                description: `Станьте участником и получите максимум возможностей,
            представляя свою компанию на уникальном отраслевом
            событии в России и странах СНГ.`,
            },
            attendee: {
                title: 'Посетителям',
                description: `Оставайтесь в курсе последних тенденций отрасли и
            продвигайте свой бизнес вместе с RUBAE.`,
            },
            opportunities: {
                title: 'Дополнительные возможности',
                description: `Сделайте ваше пребывание на выставке удобнее и
            эффективнее.`,
            },
            registration: {
                title: ' ',
                description: `Aircraft registration with Bermuda.`,
            },
        },
    },
    exhibitors: {
        exhibitors: {
            title: 'Участники',
            buttonTitle: 'Станьте участником',
            text: 'Открыт прием заявок на участие в RUBAE2021.',
            links: {
                'exhibitor-manual': 'Руководство участника',
                'pages/general-contractor': 'Генеральный застройщик',
                'pages/freight-forwarder': 'Официальный экспедитор',
                'pages/catering-partner': 'Официальный кейтеринг-партнер',
                'pages/visa-support': 'Визовая поддержка',
            },
            personalAccountButton: 'Вход в личный кабинет',
        },
        attendee: {
            title: 'Посетители',
            buttonTitle: 'Купить билет',
            text:
                'Центр бизнес-авиации Внуково-3 приглашает посетить единственное событие в отрасли деловой авиации в России и странах СНГ в период с 8 по 10 сентября 2021 года.',
            links: {
                'pages/about': 'Основная информация',
                'pages/location': 'Местоположение',
                'pages/exhibitor-list': 'Список участников',
                pavilion_exposition: 'Схема выставочной экспозиции',
            },
        },
    },
    sponsors: 'Партнеры',
    participants: 'При участии',
    'info-sponsors': 'Информационная поддержка',
    advertisement: 'Прочая реклама',
    contacts: {
        title: 'Свяжитесь с нами',
        legalInfo: 'Правовая информация',
        confidention: 'Соглашение о конфиденциальности',
    },
    contactForm: {
        name: 'Название компании',
        contactPerson: 'Контактное лицо',
        tel: 'Телефон',
        email: 'E-mail',
        address: 'Адрес',
        website: 'Веб-сайт',
        promo: 'Промо код',
        boothNumber: 'Номер стенда',
        stand: 'Стенд',
        static: 'Статика',
        submit: 'Отправить',
        formatLabel: 'Формат участия',
        successMessage: 'Спасибо! Мы обязательно свяжемся с Вами.',
        errorMessage: 'Что-то пошло не так, попробуйте позже.',
    },
    conferenceProgramForm: {
        formTitle: 'Заявка на участие в деловой программе',
        name: 'ФИО',
        company: 'Компания',
        email: 'E-mail',
        subject: 'Тема презентации',
        submit: 'Отправить',
        successMessage: 'Спасибо! Мы обязательно свяжемся с Вами.',
        errorMessage: 'Что-то пошло не так, попробуйте позже.',
    },
    exhibitApplication: {
        applicationTypeButton: 'Выберите тип размещения',
        valuePlaceholder: 'Введите значение',
        services: {
            shellScheme: {
                title: 'Оборудованная площадь (мин. 6㎡)',
                description:
                    'ОБОРУДОВАННАЯ ПЛОЩАДЬ включает: выставочную площадь, стеновые панели, ковровое покрытие, 1 электрическую розетку, 1 стол, 2 стула, 1 лампа, фризовую панель, страхование ответственности, информацию о компании в официальном каталоге RUBAE. Строительство стенда осуществляется Генеральным застройщиком RUBAE.',
            },
            spaceOnly: {
                title: 'Необорудованная площадь (мин. 18㎡)',
                description:
                    'НЕОБОРУДОВАННАЯ ПЛОЩАДЬ включает:страхование ответственности, информацию о компании в официальном каталоге RUBAE. Строительство и оформление стенда осуществляется согласно требованиям руководства участника.',
            },
            staticDisplayChalet3: {
                title: 'Шале на статической площадке (3×3)',
                description:
                    'ШАЛЕ включает:название компании над входом, 1 розетку, ковровое покрытие.',
            },
            staticDisplayChalet6: {
                title: 'Шале на статической площадке (6×6)',
                description:
                    'ШАЛЕ включает:название компании над входом, 1 розетку, ковровое покрытие.',
            },
            brokerProject: {
                title: 'Broker project',
                description:
                    'WORKING DESK includes: carpeting, 1 electrical socket, 1 branded desk, 1 chair, 1 banner 1.0 x 2.5 meter, liability insurance, company profile in the official RUBAE catalogue, access to broker lounge. The building of the stand is carried out by the RUBAE Official Contractor Company.',
            },
            firstTimeExhibitor: {
                title: 'First Time Exhibitor',
                description:
                    'РАБОЧЕЕ МЕСТО включает: ковровое покрытие; 1 розетка до 1кВт; 1 логотип, 2 стула, 1 панель 1.0 x 2.5 полноцветная печать на пленке; описание компании в официальном каталоге RUBAE; 4 бейджа. Застройку Рабочего места осуществляет Генеральный застройщик RUBAE.',
            },
            upperDeck: {
                title: 'Второй этаж (double storey - space only)',
            },
            wallBrandingChalet3: {
                title: 'Брендирование стены (для шале 3×3)',
            },
            wallBrandingChalet5: {
                title: 'Брендирование стены (для шале 6×6)',
            },
            catalogueAdPage05: { title: '1/2 полоса, полноцвет.' },
            catalogueAdPage1: { title: '1/1 полоса, полноцвет.' },
            staticDisplay: {
                title: 'Статическая площадка',
                description: 'Статическая площадка',
                length: 'Длина воздушного судна',
                wingspan: 'Размах крыла',
            },
        },
        units: {
            sqrm: '㎡',
            unit: 'шт.',
            m: 'm',
        },
        addButton: 'Добавить размещение',
        catalogueAd: 'Реклама в официальном каталоге',
        total: 'Итого от',
        formTitle: 'Заявка на участие',
        contactsTitle: 'Контакты',
        contactsSubtitle: '(все поля обязательны)',
        allocationTitle: 'Размещение',
        comment:
            'Данная заявка является основанием для заключения договора и выставления счета, который должен быть оплачен в размере 50% в течении 10 дней после его выставления. Расчет 50% до 31 июля 2021 года. Обращаем Ваше внимание на то, что предоплата 50% не возвращается в случае отказа компании от участия в выставке.',
    },
    pages: {
        schedule: {
            about: 'Общая информация',
            registration: 'Регистрация',
            preview: 'Анонс',
            schedule: 'Программа',
            scheduleLink: 'Скачать программу конференций выставки RUBAE',
        },
        exhibitors: {
            filterDefault: 'Категория',
            filterAll: 'Все',
        },
    },
    gallery: 'Фотогалерея',
    scheduleWidget: {
        dates: 'Сентября 2021',
        address: 'Центр Бизнес-Авиации Внуково-3, Москва, Россия',
        date1: 'Среда, 8 Сентября',
        date2: 'Четверг, 9 Сентября',
        date3: 'Пятница, 10 Сентября',
        covid19: 'COVID-19 правила безопасности',
        covid19Link: '/files/COVID-19_rus.pdf',
    },
};



// WEBPACK FOOTER //
// ./src/data/messages/ru.js